import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { checkAppPermissions } from '@ui/guards/route-checks';
export const Route = createFileRoute('/org/$organization/$project/app/$application/settings')({
    beforeLoad: async (param)=>{
        let { params, context: { queryClient } } = param;
        const can = await checkAppPermissions(queryClient, params.organization, params.project, params.application);
        if (!(can === null || can === void 0 ? void 0 : can.updateApplicationSettings)) {
            throw redirect({
                to: '/403',
                search: {
                    from: '/org/$organization/$project/app/$application/settings'
                }
            });
        }
    },
    component: Component
});
function Component() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
